import { map } from 'rxjs/operators';
import { Injectable } from '@angular/core';
import { HttpClient, HttpResponse } from '@angular/common/http';
import { Observable, Subject } from 'rxjs';
import { EnvironmentService } from './environment.service';
import { UrlSegments } from '../jurisdiction/jurisdiction.constants';
import { Companies } from '../model/companies';

@Injectable()
export class CommunicationService {
  private readonly baseUrl: string;
  private readonly triggerActionOnDashboardClick$: Subject<boolean>;

  constructor(private httpClient: HttpClient, private environmentService: EnvironmentService) {
    this.baseUrl = this.environmentService.apiUrl;
    this.triggerActionOnDashboardClick$ = new Subject<boolean>();
  }

  get registerForActionOnDashboardClick(): Subject<boolean> {
    return this.triggerActionOnDashboardClick$;
  }

  getData<T>(paramValue: string, responseType = {}): Observable<T> {
    return this.httpClient.get<T>(this.baseUrl + paramValue, responseType);
  }

  updateData<T>(paramValue: string, requestData: any): Observable<T> {
    return this.httpClient.put<T>(this.baseUrl + paramValue, requestData);
  }

  postData<T>(paramValue: string, requestData: any): Observable<T> {
    return this.httpClient.post<T>(this.baseUrl + paramValue, requestData);
  }

  deleteData<T>(paramValue: string): Observable<T> {
    return this.httpClient.delete<T>(this.baseUrl + paramValue);
  }

  getBlobData(paramValue: string, responseType: any = {}): Observable<{ fileName: string; blob: Blob }> {
    responseType = {
      responseType: 'blob',
      observe: 'response',
      ...responseType,
    };

    responseType.headers.Accept = 'blob';

    return this.httpClient.get<Blob>(this.baseUrl + paramValue, responseType).pipe(
      map((response: any) => {
        const contentDisposition = response.headers.get('content-disposition');
        const filename = contentDisposition.split(';')[1].split('filename')[1].split('=')[1].trim();
        return { fileName: filename, blob: response.body };
      })
    );
  }

  loginPostData<T>(paramValue: string, requestData: any): Observable<HttpResponse<T>> {
    return this.httpClient.post<T>(this.baseUrl + paramValue, requestData, { observe: 'response' });
  }

  dashboardLogoClick(manualLogoutProcess: boolean): void {
    this.triggerActionOnDashboardClick$.next(manualLogoutProcess);
  }

  getMeterCharacteristicDetails(meterSize: string): Observable<any> {
    return this.httpClient.get(`${this.baseUrl}${UrlSegments.GetMeterCharacteristic}${meterSize}`);
  }

  getCompany(taxId: string): Observable<Companies> {
    return this.getData(`company?tax_id=${taxId}`);
  }
}
